import axios from "axios";
import instance from "../../../axios";

export const API_URL = `${process.env.REACT_APP_UPLOAD_URL}`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;

// READ
export function uploadImage(file) {
  // let formData = new FormData();
  // formData.append('file', file);
  // let url = BASE_URL+'/image/upload'

  // console.log("url",url)

  // return axios.post(`${url}`, formData);

  let formData = new FormData();
  formData.append('file', file);
  // let url ='http://localhost:9155/api/common/upload-image'
  let url = BASE_URL+'/image/upload'

  return instance.post(`${url}`, formData);
}